import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=1e12511b&scoped=true"
import script from "./widget.vue?vue&type=script&lang=js"
export * from "./widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e12511b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e12511b')) {
      api.createRecord('1e12511b', component.options)
    } else {
      api.reload('1e12511b', component.options)
    }
    module.hot.accept("./widget.vue?vue&type=template&id=1e12511b&scoped=true", function () {
      api.rerender('1e12511b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/widget.vue"
export default component.exports